import React from 'react';
import { useTranslation } from 'react-i18next';

const LiveScoreboard = ({ team, teamName, side }) => {
  const { t } = useTranslation();
  const players = Object.values(team?.players || {});
  const sortedPlayers = [...players].sort((a, b) => b.kills - a.kills);

  return (
    <div className={`live-team-section ${side?.toLowerCase()}`}>
      <div className="live-team-header">
        <span className="live-team-name">{teamName}</span>
        <span className="live-team-score">{team?.score || 0}</span>
      </div>
      <table className="live-player-table">
        <thead>
          <tr>
            <th>{t('palette.typePlayer')}</th>
            <th>K</th>
            <th>D</th>
            <th>A</th>
            <th>ADR</th>
          </tr>
        </thead>
        <tbody>
          {sortedPlayers.map(player => (
            <tr key={player.steam_id} className={player.alive ? '' : 'dead'}>
              <td className="player-cell">
                <span className={`alive-dot ${player.alive ? 'alive' : 'dead'}`}></span>
                {player.name}
              </td>
              <td>{player.kills}</td>
              <td>{player.deaths}</td>
              <td>{player.assists}</td>
              <td>{player.adr?.toFixed(1) || '0.0'}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default LiveScoreboard;
